/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Appointment/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import ActionsDialog from './ActionsDialog/index'
import AppointmentStatus from './AppointmentStatus/index'
import AppointmentType from './AppointmentType/index'
import ConfirmedIcon from './ConfirmedIcon/index'
import InfoDialog from './InfoDialog/index'
import Notes from './Notes/index'
import PatientComms from 'DesignSystem/PatientComms/index'
import PatientName from './PatientName/index'
import PaymentOverdueIcon from './PaymentOverdueIcon/index'
import React from 'react'
import StateIcon from './StateIcon/index'
import Time from './Time/index'
import TreatmentColors from './TreatmentColors/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Appointment({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Appointment",
  triggerRef,
  onMouseEnter,
  onMouseLeave,
  onMouseMove,
  hovered,
  top,
  left,
  contentRef,
  onMouseEnterContent,
  update
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
let eventIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'id',
})
let eventShouldHighlightValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'shouldHighlight',
})
let eventStateValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'state',
})
let constantData = 'CHECKED_OUT'
let aggregateData = fromAggregate.equals(eventStateValueData, constantData)
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  triggerRef,
  onMouseEnter,
  onMouseLeave,
  onMouseMove,
  hovered,
  top,
  left,
  contentRef,
  onMouseEnterContent,
  update
  
})
let onContextMenu = fromHelpers.useOnContextMenu({
  children,
  viewPath,
  triggerRef,
  onMouseEnter,
  onMouseLeave,
  onMouseMove,
  hovered,
  top,
  left,
  contentRef,
  onMouseEnterContent,
  update
  
})
let eventValueData = fromData.useDataFormat({ viewPath,
context: 'event',
format: fromHelpers.getAppointmentTypeColor,
})
let tabSelectedAppointmentQueueValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.appointment_queue',
})
let eventValueData1 = fromData.useDataValue({ viewPath,
context: 'event',
})
let aggregateData1 = fromAggregate.containsItemWithId(tabSelectedAppointmentQueueValueData, eventValueData1)
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let settingsChairsInViewValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'chairs_in_view',
})
let constantData1 = 5
let aggregateData2 = fromAggregate.isLessThan(settingsChairsInViewValueData, constantData1)
let settingsChairsInViewValueData1 = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'chairs_in_view',
})
let constantData2 = 5
let aggregateData3 = fromAggregate.isGreaterThanOrEqualTo(settingsChairsInViewValueData1, constantData2)
let eventAppointmentPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.patient._id',
})
let eventAppointmentPatientPersonValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.patient.person',
})
  return (<React.Fragment
>
<div
  data-testid="Appointment.Vertical"
  data-view-path={viewPath}
 id={eventIdValueData}
 ref={triggerRef}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 onMouseMove={onMouseMove}
 className={`views-block ${styles.Vertical}`}
>
<button
  data-testid="Appointment.Vertical:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 onContextMenu={onContextMenu}
 style={{'--bblr-2-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-3-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-4-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-5-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-1-dUIJ5': eventShouldHighlightValueData ? dtColorsNeutral100 : hovered ? dtColorsNeutral100 : dtColorsWhite,'--o-6-dUIJ5': aggregateData ? 0.7 : 1}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Appointment.Vertical:2"
  data-view-path={viewPath}
 style={{'--pt-7-dUIJ5': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pr-8-dUIJ5': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pb-9-dUIJ5': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pl-10-dUIJ5': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--blw-11-dUIJ5': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--blc-12-dUIJ5': eventValueData,'--o-6-dUIJ5': aggregateData1 ? 0.8 : 1}}
 className={`views-block ${styles.Vertical2}`}
>
<div
  data-testid="Appointment.Vertical:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical3}`}
>
<div
  data-testid="Appointment.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<PatientName
  viewPath={`${viewPath}/PatientName`}
/>
<TreatmentColors
  viewPath={`${viewPath}/TreatmentColors`}
/>
</div>
<div
  data-testid="Appointment.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<AppointmentType
  viewPath={`${viewPath}/AppointmentType`}
/>
<fromFlow.When is={aggregateData2}>
<div
  data-testid="Appointment.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<AppointmentStatus
  viewPath={`${viewPath}/AppointmentStatus`}
/>
</div>
</fromFlow.When>
</div>
<div
  data-testid="Appointment.Horizontal:3"
  data-view-path={viewPath}
 style={{'--g-13-dUIJ5': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Horizontal3}`}
>
<Time
  viewPath={`${viewPath}/Time`}
/>
<div
  data-testid="Appointment.Horizontal:4"
  data-view-path={viewPath}
 style={{'--g-13-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal4}`}
>
<StateIcon
  viewPath={`${viewPath}/StateIcon`}
/>
<ConfirmedIcon
  viewPath={`${viewPath}/ConfirmedIcon`}
/>
<PaymentOverdueIcon
  viewPath={`${viewPath}/PaymentOverdueIcon`}
/>
</div>
</div>
<fromFlow.When is={aggregateData3}>
<div
  data-testid="Appointment.Horizontal:5"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal5}`}
>
<AppointmentStatus
  viewPath={`${viewPath}/AppointmentStatus`}
/>
</div>
</fromFlow.When>
<Notes
  viewPath={`${viewPath}/Notes`}
/>
</div>
</div>
</button>
<InfoDialog
  viewPath={`${viewPath}/InfoDialog`}
 top={top}
 left={left}
 contentRef={contentRef}
 onMouseEnter={onMouseEnterContent}
 update={update}
/>
<PatientComms
 viewPath={viewPath}
 data="event.appointment.patient._id"
 patient_id={eventAppointmentPatientIdValueData}
 data="event.appointment.patient.person"
 person={eventAppointmentPatientPersonValueData}
>
{childProps => (
<ActionsDialog
{...childProps}
  viewPath={`${viewPath}/ActionsDialog`}
 top={top}
 left={left}
 contentRef={contentRef}
 onMouseEnter={onMouseEnterContent}
 update={update}
/>
)}
</PatientComms>
</div>
{children}
</React.Fragment>)
}